// angular
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
// store
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

// libraries
import { ClaimDrpSearchFeatureModule } from '@amfam/claim/drp-search/feature';
import { ClaimPhotoUploadFeatureModule } from '@amfam/claim/photo-upload/feature';
import { PipesModule } from '@amfam/shared/ui/pipes';
import { BrandDirectivesModule } from '@amfam/shared/utility/brand';
import { SharedServicesModule } from '@amfam/shared/utility/shared-services';
import { UiKitModule } from '@amfam/ui-kit';

import { PostFnolEffects } from './+state/post-fnol.effects';
import {
  POSTFNOL_FEATURE_KEY,
  initialState as postFnolInitialState,
  postFnolReducer
} from './+state/post-fnol.reducer';
// dumb presentation components

// smart container components
import { PostFnolComponent } from './containers/post-fnol/post-fnol.component';

@NgModule({
  imports: [
    CommonModule,
    ClaimDrpSearchFeatureModule,
    UiKitModule,
    SharedServicesModule,
    ClaimPhotoUploadFeatureModule,
    RouterModule,
    PipesModule,
    BrandDirectivesModule,
    StoreModule.forFeature(POSTFNOL_FEATURE_KEY, postFnolReducer, {
      initialState: postFnolInitialState
    }),
    EffectsModule.forFeature([PostFnolEffects])
  ],
  declarations: [PostFnolComponent],
  exports: [PostFnolComponent]
})
export class ClaimPostFnolFeatureModule {}
